// Mock data for Cortexa AI Marketing Agency

export const caseStudies = [
  {
    id: 1,
    client: "Luxe Fashion Co.",
    industry: "E-commerce",
    problem: "Low ROAS and high customer acquisition costs on paid advertising channels",
    solution: "Implemented AI-powered ad optimization system with predictive audience targeting and dynamic creative testing",
    results: [
      { metric: "ROAS Increase", value: "340%" },
      { metric: "CPA Reduction", value: "67%" },
      { metric: "Revenue Growth", value: "$2.4M" }
    ],
    duration: "6 months",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
  },
  {
    id: 2,
    client: "CloudSync SaaS",
    industry: "B2B SaaS",
    problem: "Struggling to generate qualified leads and scale outbound efforts",
    solution: "Deployed AI chatbot for lead qualification and automated nurture sequences with personalized AI content",
    results: [
      { metric: "Lead Volume", value: "10x" },
      { metric: "Qualification Rate", value: "85%" },
      { metric: "Sales Cycle", value: "-40%" }
    ],
    duration: "4 months",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80"
  },
  {
    id: 3,
    client: "Urban Realty Group",
    industry: "Real Estate",
    problem: "Time-consuming content creation limiting property marketing reach",
    solution: "Built AI content system generating property descriptions, social posts, and email campaigns at scale",
    results: [
      { metric: "Content Speed", value: "5x faster" },
      { metric: "Listings Marketed", value: "+300%" },
      { metric: "Engagement Rate", value: "+125%" }
    ],
    duration: "3 months",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    id: 4,
    client: "FitTech Wellness",
    industry: "Health & Fitness",
    problem: "Low conversion rates from website traffic and abandoned carts",
    solution: "Integrated AI sales agents with behavioral triggers and personalized product recommendations",
    results: [
      { metric: "Conversion Rate", value: "+180%" },
      { metric: "Cart Recovery", value: "62%" },
      { metric: "AOV Increase", value: "$47" }
    ],
    duration: "5 months",
    image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=800&q=80"
  }
];

export const services = [
  {
    id: 'ai-studio',
    slug: 'ai-product-photoshoots',
    title: "AI Studio – Product Photoshoots",
    icon: "Camera",
    shortDescription: "AI-generated premium product photography for ads, social media, and websites.",
    fullDescription: "Transform your product visuals with AI-powered photoshoots. Get studio-quality product photography without expensive photoshoots, lighting setups, or location rentals.",
    benefits: [
      "Professional studio-quality images in minutes",
      "Multiple backgrounds and settings",
      "Consistent brand aesthetics",
      "Cost-effective vs traditional photoshoots"
    ],
    pricing: "Starting from ₹599/project",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&q=80"
  },
  {
    id: 'ai-cinematic',
    slug: 'ai-cinematic-ads',
    title: "AI Cinematic Ads",
    icon: "Film",
    shortDescription: "Short cinematic product advertisements designed for social media marketing.",
    fullDescription: "Create thumb-stopping video ads that convert. Our AI-powered system generates cinematic product advertisements optimized for Instagram, TikTok, and Facebook.",
    benefits: [
      "High-conversion video ads",
      "Platform-optimized formats",
      "Professional editing & effects",
      "Fast turnaround time"
    ],
    pricing: "Starting from ₹1299/video",
    image: "https://images.unsplash.com/photo-1492619375914-88005aa9e8fb?w=800&q=80"
  },
  {
    id: 'ai-models',
    slug: 'ai-model-campaigns',
    title: "AI Model Campaigns",
    icon: "Users",
    shortDescription: "AI-generated models showcasing products in luxury campaign visuals.",
    fullDescription: "Launch luxury brand campaigns with AI-generated models. Perfect product placement, diverse representation, and premium aesthetics without model hiring costs.",
    benefits: [
      "Diverse model representation",
      "Luxury campaign aesthetics",
      "Unlimited variations",
      "No model hiring costs"
    ],
    pricing: "Starting from ₹1299/campaign",
    image: "https://images.unsplash.com/photo-1509631179647-0177331693ae?w=800&q=80"
  },
  {
    id: 'website-design',
    slug: 'website-design',
    title: "Website Design",
    icon: "Globe",
    shortDescription: "Modern high-conversion websites designed for brands.",
    fullDescription: "Get a premium website that converts visitors into customers. We design and build modern, fast, and conversion-optimized websites for ambitious brands.",
    benefits: [
      "Mobile-responsive design",
      "Conversion-optimized layouts",
      "Fast loading speeds",
      "SEO-ready architecture"
    ],
    pricing: "Starting from ₹999/site",
    image: "https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=800&q=80"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "CMO, Luxe Fashion Co.",
    content: "Cortexa transformed our advertising performance. The AI optimization delivered results we couldn't achieve with traditional agencies. ROI speaks for itself.",
    avatar: "https://i.pravatar.cc/150?img=1"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Founder, CloudSync SaaS",
    content: "The AI chatbot system they built generates more qualified leads in a week than our previous team did in a month. Game-changing technology.",
    avatar: "https://i.pravatar.cc/150?img=13"
  },
  {
    id: 3,
    name: "David Rodriguez",
    role: "CEO, Urban Realty Group",
    content: "Content production was our bottleneck. Cortexa's AI system freed up our team to focus on closing deals while maintaining quality at scale.",
    avatar: "https://i.pravatar.cc/150?img=12"
  }
];

export const agencyInfo = {
  name: "Cortexa",
  tagline: "AI Ad Creatives & Product Campaigns for Modern Brands",
  subtagline: "Cortexa creates AI-powered product photoshoots, cinematic ads, AI model campaigns, and high-converting websites for brands.",
  email: "cortexahq@gmail.com",
  instagram: "@cortexahq",
  whatsapp: "+91 9810737396",
  about: "We're not your typical marketing agency. We build intelligent systems that work while you sleep. By combining cutting-edge AI technology with proven growth strategies, we create marketing machines that scale your business without scaling your team. Our mission is simple: leverage artificial intelligence to give you an unfair advantage in your market."
};

// Before/After Portfolio Items
export const beforeAfterPortfolio = [
  {
    id: 'ba-1',
    title: 'E-commerce Website Redesign',
    category: 'Web Design',
    description: 'Complete website overhaul with AI-optimized user experience',
    beforeImage: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=1200&q=80',
    afterImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&q=80',
    results: '+340% conversion rate'
  },
  {
    id: 'ba-2',
    title: 'Social Media Campaign Transformation',
    category: 'Social Media',
    description: 'AI-powered content strategy that increased engagement',
    beforeImage: 'https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=1200&q=80',
    afterImage: 'https://images.unsplash.com/photo-1611162616475-46b635cb6868?w=1200&q=80',
    results: '+580% engagement'
  },
  {
    id: 'ba-3',
    title: 'Email Marketing Redesign',
    category: 'Email Marketing',
    description: 'AI-optimized email templates with personalization',
    beforeImage: 'https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?w=1200&q=80',
    afterImage: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=1200&q=80',
    results: '+250% open rates'
  },
  {
    id: 'ba-4',
    title: 'Landing Page Optimization',
    category: 'Conversion Optimization',
    description: 'AI-tested landing page variants for maximum conversion',
    beforeImage: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=1200&q=80',
    afterImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80',
    results: '+420% conversions'
  }
];